import { load } from "../../events/load";

const i18n = () => window.params?.i18n || {};

const initMoreAboutReadMore = () => {
    const readMoreButton = document.querySelector(".more-about__read-more");
    if (!readMoreButton) return;

    const rightBlock = readMoreButton.closest(".more-about__right");
    if (!rightBlock) return;

    const postId = readMoreButton.dataset.postId;
    if (!postId) return;

    let isLoading = false;
    let isExpanded = false;
    let loadedTextsContainer = null;

    readMoreButton.addEventListener("click", async () => {
        if (isLoading) return;

        const textElement = readMoreButton.querySelector(".btn__text");

        if (!isExpanded) {
            isLoading = true;
            const originalText = textElement?.textContent || "";

            if (textElement) textElement.textContent = i18n().loading || "Loading...";
            readMoreButton.disabled = true;

            try {
                const formData = new FormData();
                formData.append("action", "load_more_about_texts");
                formData.append("nonce", window.params?.nonce || "");
                formData.append("post_id", postId);

                const response = await fetch(
                    window.params?.ajax_url || "/wp-admin/admin-ajax.php",
                    {
                        method: "POST",
                        body: formData,
                    }
                );

                const result = await response.json();

                if (result.success) {
                    loadedTextsContainer = document.createElement("div");
                    loadedTextsContainer.className = "more-about__texts-loaded";
                    loadedTextsContainer.innerHTML = result.data.html;

                    readMoreButton.insertAdjacentElement(
                        "afterend",
                        loadedTextsContainer
                    );

                    loadedTextsContainer.insertAdjacentElement(
                        "afterend",
                        readMoreButton
                    );

                    isExpanded = true;
                    readMoreButton.classList.add("is-expanded");
                    if (textElement) textElement.textContent = i18n().text_collapse || "Collapse";
                } else {
                    if (textElement) textElement.textContent = originalText;
                }
            } catch (error) {
                console.error("AJAX error:", error);
                if (textElement) textElement.textContent = originalText;
            } finally {
                isLoading = false;
                readMoreButton.disabled = false;
            }
        } else {
            if (loadedTextsContainer) {
                const firstText = rightBlock.querySelector(".more-about__text");
                if (firstText) {
                    firstText.insertAdjacentElement("afterend", readMoreButton);
                }

                loadedTextsContainer.remove();
                loadedTextsContainer = null;
            }

            isExpanded = false;
            readMoreButton.classList.remove("is-expanded");
            if (textElement) textElement.textContent = i18n().btn_read_more_expand || "Read more";
        }
    });
};

load(initMoreAboutReadMore);